export enum MixAndMatchCategoryEnum {
  TOP = 'top',
  BOTTOM = 'bottom',
  FOOTWEAR = 'footwear',
  SOCK = 'sock',
  OUTERWEAR = 'outerwear',
  BODYSUIT = 'top_bottom',
  DRESS = 'one_piece',
}

export enum MixAndMatchUnderwearEnum {
  UNDERWEAR_TOP = 235,
  UNDERWEAR_BOTTOM = 234,
}

export enum MixAndMatchDefaultEnum {
  TOP = 54,
  BOTTOM = 137,
  FOOTWEAR = 0,
}

export enum MixAndMatchTuckStateEnum {
  TUCK = 1,
  UNTUCK = 0,
}

export enum MixAndMatchDefaultTuckStateEnum {
  NONE = 'none',
  TUCK = 'tuck',
  UNTUCK = 'untuck',
}
